export default {
  options: {
    true: 'Ja',
    false: 'Nee',
  },
};
